import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export type ClientType = 'buy' | 'sell' | 'lease'

export const clientTypeMap: Record<ClientType, MapItem> = {
  buy: { label: 'Buy' },
  sell: { label: 'Sell' },
  lease: { label: 'Lease' },
}

export const clientTypeSchema = z.enum(Object.keys(clientTypeMap) as [ClientType, ...ClientType[]])
